module.exports = __webpack_public_path__ + "img/spain-blood-diseases-male.3ad22397.png";